(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clampValue = (value) => Math.min(100, Math.max(0, Number(value)));

  class ComparisonSlider extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.enhanced === 'true') return;

      this.sliderOverlay = this.querySelector('.comparison-slider__overlay');
      this.sliderLine = this.querySelector('.comparison-slider__line');
      this.sliderInput = this.querySelector('.comparison-slider__input');

      if (!this.sliderOverlay || !this.sliderLine || !this.sliderInput) {
        return;
      }

      this.dataset.enhanced = 'true';
      this.isDragging = false;
      this.activePointerId = null;

      this.boundHandleInput = this.handleInput.bind(this);
      this.boundPointerDown = this.handlePointerDown.bind(this);
      this.boundPointerMove = this.handlePointerMove.bind(this);
      this.boundPointerUp = this.handlePointerUp.bind(this);
      this.boundClick = this.handleClick.bind(this);

      this.sliderInput.addEventListener('input', this.boundHandleInput);
      this.sliderInput.addEventListener('change', this.boundHandleInput);

      this.addEventListener('pointerdown', this.boundPointerDown);
      this.addEventListener('pointermove', this.boundPointerMove);
      this.addEventListener('pointerup', this.boundPointerUp);
      this.addEventListener('pointerleave', this.boundPointerUp);
      this.addEventListener('click', this.boundClick);

      this.updateUI(this.sliderInput.value || 50);
    }

    clamp(value) {
      return clampValue(value);
    }

    updateUI(value) {
      const numericValue = this.clamp(value);
      this.sliderInput.value = numericValue;
      this.sliderOverlay.style.width = `${numericValue}%`;
      this.sliderLine.style.left = `${numericValue}%`;
    }

    valueFromPointer(event) {
      const rect = this.getBoundingClientRect();
      const position = (event.clientX - rect.left) / rect.width;
      return this.clamp(position * 100);
    }

    handleInput(event) {
      this.updateUI(event.target.value);
    }

    handlePointerDown(event) {
      this.isDragging = true;
      this.activePointerId = event.pointerId ?? null;
      this.setPointerCapture?.(this.activePointerId);
      event.preventDefault();
      this.updateUI(this.valueFromPointer(event));
    }

    handlePointerMove(event) {
      if (!this.isDragging) return;
      if (this.activePointerId !== null && event.pointerId !== this.activePointerId) return;
      event.preventDefault();
      this.updateUI(this.valueFromPointer(event));
    }

    handlePointerUp(event) {
      if (!this.isDragging) return;
      if (this.activePointerId !== null && event.pointerId && event.pointerId !== this.activePointerId) {
        return;
      }
      this.isDragging = false;
      if (this.activePointerId !== null) {
        this.releasePointerCapture?.(this.activePointerId);
        this.activePointerId = null;
      }
    }

    handleClick(event) {
      if (event.target === this.sliderInput) {
        return;
      }
      this.updateUI(this.valueFromPointer(event));
    }
  }

  if (!customElements.get('comparison-slider')) {
    customElements.define('comparison-slider', ComparisonSlider);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
